import { useEffect, useRef } from 'react';
import { View, Text, StyleSheet, Animated } from 'react-native';
import { Colors } from '@/constants/colors';

interface Props {
  minute?: number;
  period?: number;
  clock?: string;
  sport?: 'futebol' | 'nba' | 'nfl';
  isHalftime?: boolean;
}

export function LiveBadge({ minute, period, clock, sport = 'futebol', isHalftime }: Props) {
  const opacity = useRef(new Animated.Value(1)).current;

  useEffect(() => {
    const pulse = Animated.loop(
      Animated.sequence([
        Animated.timing(opacity, { toValue: 0.3, duration: 600, useNativeDriver: true }),
        Animated.timing(opacity, { toValue: 1, duration: 600, useNativeDriver: true }),
      ])
    );
    pulse.start();
    return () => pulse.stop();
  }, []);

  if (isHalftime) {
    return (
      <View style={[styles.badge, styles.halftime]}>
        <Text style={styles.halftimeText}>INTERVALO</Text>
      </View>
    );
  }

  let timeLabel = 'AO VIVO';
  if (sport === 'futebol' && minute) timeLabel = `${minute}'`;
  if (sport === 'nba' && period) timeLabel = clock ? `P${period} ${clock}` : `P${period}`;
  if (sport === 'nfl' && period) timeLabel = clock ? `Q${period} ${clock}` : `Q${period}`;

  return (
    <View style={styles.badge}>
      <Animated.View style={[styles.dot, { opacity }]} />
      <Text style={styles.text}>{timeLabel}</Text>
    </View>
  );
}

const styles = StyleSheet.create({
  badge: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: 'rgba(239, 68, 68, 0.15)',
    borderRadius: 6,
    paddingHorizontal: 8,
    paddingVertical: 3,
    gap: 5,
    borderWidth: 1,
    borderColor: 'rgba(239, 68, 68, 0.3)',
  },
  halftime: {
    backgroundColor: 'rgba(251, 191, 36, 0.15)',
    borderColor: 'rgba(251, 191, 36, 0.3)',
  },
  dot: {
    width: 6,
    height: 6,
    borderRadius: 3,
    backgroundColor: Colors.live,
  },
  text: {
    color: Colors.live,
    fontSize: 10,
    fontWeight: '700',
    letterSpacing: 0.5,
  },
  halftimeText: {
    color: '#fbbf24',
    fontSize: 10,
    fontWeight: '700',
    letterSpacing: 0.5,
  },
});
